import { lighterGrey } from "constants/colors";
import { BREAKPOINT_TABLET } from "constants/constants";

import styled from "styled-components/macro";
import {
  getAheadBehindColors,
  AHEAD_BEHIND_TILE_WIDTH_MOBILE,
  AHEAD_BEHIND_TILE_HEIGHT,
  AHEAD_BEHIND_TILE_WIDTH,
} from "../aheadBehindUtils";

type AheadBehindTileProps = {
  outputLossSum: number | null;
  outputLossSumColorOnly?: number | null;
  metricDisplayOverride?: string | JSX.Element | null;
};

/** A coloured div to display output loss; backgroundColor: positive = green, negative = red, null = grey */
export default function AheadBehindTile({
  outputLossSum,
  outputLossSumColorOnly,
  metricDisplayOverride,
}: AheadBehindTileProps) {
  const { backgroundColor, textColor } = getAheadBehindColors({
    outputLossSum: outputLossSumColorOnly ?? outputLossSum,
    defaultBackgroundColor: lighterGrey,
  });

  const outputLossDisplay =
    typeof outputLossSum === "number"
      ? `${outputLossSum > 0 ? "+" : ""}${outputLossSum.toFixed(0)}`
      : "--";
  return (
    <AheadBehindTileStyles
      $backgroundColor={backgroundColor}
      $textColor={textColor}
      data-component-name="Ahead/Behind Tile"
    >
      <div className="outputLossLabel">
        {metricDisplayOverride ?? outputLossDisplay}
      </div>
    </AheadBehindTileStyles>
  );
}

const AheadBehindTileStyles = styled.div<{
  $backgroundColor: string;
  $textColor: string;
}>`
  width: ${AHEAD_BEHIND_TILE_WIDTH_MOBILE}px;
  height: ${AHEAD_BEHIND_TILE_HEIGHT}px;

  background: ${props => props.$backgroundColor};
  border-radius: 4px;

  color: ${props => props.$textColor};
  font-family: "Open Sans";
  font-weight: 500;
  font-size: 56px;
  line-height: 113px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  @media (min-width: ${BREAKPOINT_TABLET}px) {
    font-size: 83px;
    width: ${AHEAD_BEHIND_TILE_WIDTH}px;
  }
`;
